module.exports = __webpack_public_path__ + "static/media/thumbs_up_active.42f5dfc2.svg";